<template>
    <div>
    <tti-header></tti-header>

<!-- This example requires Tailwind CSS v2.0+ -->
<div class="mx-auto px-3 sm:px-5">
  <!-- Content goes here -->

    <!-- This example requires Tailwind CSS v2.0+ -->
<nav class="flex" aria-label="Breadcrumb">
  <ol class="flex items-center space-x-4">
    <!-- <li>
      <div>
        <a href="#" class="text-gray-400 hover:text-gray-500">
          <!- Heroicon name: solid/home ->
          <svg class="flex-shrink-0 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
          </svg>
          <span class="sr-only">Home</span>
        </a>
      </div>
    </li> -->
    <li>
      <div class="flex items-center">
        <svg class="flex-shrink-0 h-6 w-6 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="white" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M9 12H15M9 16H15M17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H12.5858C12.851 3 13.1054 3.10536 13.2929 3.29289L18.7071 8.70711C18.8946 8.89464 19 9.149 19 9.41421V19C19 20.1046 18.1046 21 17 21Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <router-link to="/articles" class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700">Articles</router-link>
      </div>
    </li>
    <li v-if="articleDetails">
      <div class="flex items-center">
        <svg class="flex-shrink-0 h-5 w-5 text-gray-300" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
          <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
        </svg>
        <span aria-current="page" class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700">{{ articleDetails.title }}</span>
      </div>
    </li>
  </ol>
</nav>
</div>





    <!-- This example requires Tailwind CSS v2.0+ -->


    <!-- This example requires Tailwind CSS v2.0+ -->
<!-- <div>
  <div>
    <nav class="sm:hidden" aria-label="Back">
      <a href="#" class="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700">
        <!- Heroicon name: solid/chevron-left ->
        <svg class="flex-shrink-0 -ml-1 mr-1 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
        </svg>
        Back
      </a>
    </nav>
    <nav class="hidden sm:flex" aria-label="Breadcrumb">
      <ol class="flex items-center space-x-4">
        <li>
          <div>
            <router-link to="/articles" class="text-sm font-medium text-gray-500 hover:text-gray-700">Articles</router-link>
          </div>
        </li>
        <li>
          <div class="flex items-center">
            <!- Heroicon name: solid/chevron-right ->
            <svg class="flex-shrink-0 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
            </svg>
            <a href="#" aria-current="page" class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700">My First Article</a>
          </div>
        </li>
      </ol>
    </nav>
  </div>
  <div class="mt-2 md:flex md:items-center md:justify-between">
    <div class="flex-1 min-w-0">
      <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
        My First Article
      </h2>
    </div>
    <!- <div class="mt-4 flex-shrink-0 flex md:mt-0 md:ml-4">
      <button type="button" class="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
        Edit
      </button>
      <button type="button" class="ml-3 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
        Publish
      </button>
    </div> ->
  </div>
</div> -->


<!--
  This example requires Tailwind CSS v2.0+ 
  
  This example requires some changes to your config:
  
  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/typography'),
    ]
  }
  ```
-->
<div v-if="articleDetails" class="relative pt-16 pb-8 bg-white overflow-hidden">
  <div class="hidden lg:block lg:absolute lg:inset-y-0 lg:h-full lg:w-full">
    <div class="relative h-full text-lg max-w-prose mx-auto" aria-hidden="true">
      <svg class="absolute top-12 left-full transform translate-x-32" width="404" height="384" fill="none" viewBox="0 0 404 384">
        <defs>
          <pattern id="74b3fd99-0a6f-4271-bef2-e80eeafdf357" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
            <rect x="0" y="0" width="4" height="4" class="text-gray-200" fill="currentColor" />
          </pattern>
        </defs>
        <rect width="404" height="384" fill="url(#74b3fd99-0a6f-4271-bef2-e80eeafdf357)" />
      </svg>
      <svg class="absolute top-1/2 right-full transform -translate-y-1/2 -translate-x-32" width="404" height="384" fill="none" viewBox="0 0 404 384">
        <defs>
          <pattern id="f210dbf6-a58d-4871-961e-36d5016a0f49" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
            <rect x="0" y="0" width="4" height="4" class="text-gray-200" fill="currentColor" />
          </pattern>
        </defs>
        <rect width="404" height="384" fill="url(#f210dbf6-a58d-4871-961e-36d5016a0f49)" />
      </svg>
      <svg class="absolute bottom-12 left-full transform translate-x-32" width="404" height="384" fill="none" viewBox="0 0 404 384">
        <defs>
          <pattern id="d3eb07ae-5182-43e6-857d-35c643af9034" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
            <rect x="0" y="0" width="4" height="4" class="text-gray-200" fill="currentColor" />
          </pattern>
        </defs>
        <rect width="404" height="384" fill="url(#d3eb07ae-5182-43e6-857d-35c643af9034)" />
      </svg>
    </div>
  </div>
  <div class="relative px-4 sm:px-6 lg:px-8">
    
    <div class="text-lg max-w-prose mx-auto">
      <h1>
        <span class="block text-base text-center text-blue-600 font-semibold tracking-wide uppercase">{{ articleType }}</span>
        <span class="mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">{{ articleDetails.title }}</span>
        <span class="mt-2 block text-base text-center leading-8 font- tracking-tight text-gray-500">{{ dayjs(articleDetails.publishDate).format('Do MMMM, YYYY') }}</span>
      </h1>
    </div>
    
    <div ref="articleBody" v-html="articleBody" class="mt-8 prose prose-blue text-gray-600 mx-auto md:prose-lg"></div>

    <div class="mt-12 max-w-2xl mx-auto px-4 sm:px-6 md:flex md:items-center md:justify-between md:space-x-5 lg:px-8">
    <!-- <router-link to="/tutors/1234/ricardo-cooper" class="mt-12 max-w-2xl mx-auto px-4 sm:px-6 md:flex md:items-center md:justify-between md:space-x-5 lg:px-8"> -->
      <component
        :is="articleAuthor.url ? 'a' : 'div'"
        :href="articleAuthor.url"
        class="flex items-center space-x-5"
      >
        <div class="flex-shrink-0">
          <div class="relative">
            <img class="h-16 w-16 rounded-full shadow-avatar-outline" :src="articleAuthor.photoUrl" alt="">
            <span class="absolute inset-0 shadow-inner rounded-full" aria-hidden="true"></span>
          </div>
        </div>
        <div>
          <h1 class="text-2xl font-bold text-gray-900">{{ articleAuthor.name }}</h1>
          <p v-if="articleAuthor.url" class="text-sm font-medium text-gray-500 underline">Visit {{ articleAuthor.name }}’{{ articleAuthor.name.endsWith('s') ? null : 's' }} profile</p>
        </div>
      </component>
      <!-- <div class="mt-6 flex flex-col-reverse justify-stretch space-y-4 space-y-reverse sm:flex-row-reverse sm:justify-end sm:space-x-reverse sm:space-y-0 sm:space-x-3 md:mt-0 md:flex-row md:space-x-3">
        <button type="button" class="inline-flex items-center justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-blue-500">
          View Profile
        </button>
      </div> -->
    </div>

    <div v-if="navigatorAvailable" class="mt-10 flex justify-center">
      <button type="button" @click.prevent="share" class="flex space-x-2 text-gray-500 hover:text-gray-600">
        <heroicon icon="share" class="w-6 h-6 text-gray-400"></heroicon>
        <span>Share this article</span>
      </button>
    </div>


  </div>
</div>



  



    <tti-footer></tti-footer>
    </div>
</template>
<script>
import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
dayjs.extend(advancedFormat)

import MarkdownIt from 'markdown-it'
const md = new MarkdownIt({
  typographer: true,
  html: true
})

import ArticleService from '@/services/ArticleServices'
const articleService = new ArticleService()

import TtiLogo from '../assets/logo-square-padded.png'

export default {
  components: {
    'tti-header': () => import('./HeaderNew'),
    'tti-footer': () => import('./Footer'),
    'heroicon': () => import('./Heroicon')
  },
  data() {
    return {
      dayjs,
      articleDetails: null,
      articleBody: null
    }
  },
  metaInfo() {
    return {
      title: `${this.articleDetails?.title} | The Tutor Index`,
    }
  },
  computed: {
    articleType() {
      switch (this.articleDetails.type) {
        case 'news':
          return 'News';
        case 'member':
          return 'Community Article';
        case 'article':
        default:
          return 'Article'
      }
    },
    articleAuthor() {
      return this.articleDetails.type == 'news' || this.articleDetails.type == 'article'
        ? {
          name: 'The Tutor Index',
          photoUrl: TtiLogo
        }
        : { 
          name: this.articleDetails.author,
          photoUrl: this.articleDetails.authorPhoto,
          url: this.articleDetails.authorUrl
        }
    },
    navigatorAvailable() {
      return navigator.share !== undefined;
    }
  },
  methods: {
    async loadArticle() {
      var [details, content] = await Promise.all([
        articleService.getArticleDetails(this.$route.params.url),
        articleService.getArticleContent(this.$route.params.url)
      ]);
      
      this.articleDetails = details;
      this.articleBody = md.render(content);

      this.$nextTick(() => {
        this.connectVueLinks();
      });
    },
    connectVueLinks() {
      this.$refs.articleBody.addEventListener('click', event => {
        if (event.target.tagName !== 'A')
          return;

        if (event.target && event.target.matches("a:not([href*='://'])") 
          && event.target.matches("a:not([href^='#'])") 
          && event.target.matches("a:not([href^='mailto:'])") 
          && event.target.href) {
          const url = new URL(event.target.href);
          const to = url.pathname;
          event.preventDefault();
          this.$router.push(to);
        }

        // https://stackoverflow.com/questions/62344669/vue-router-creating-a-router-link-with-a
      });
    },
    share() {
      navigator.share({
        title: this.articleDetails.title,
        url: `https://www.thetutorindex.com/articles/${this.articleDetails.url}`
      })
    }
  },
  async mounted() {
    await this.loadArticle();
  },
  async beforeRouteUpdate(to, from, next) {
    next();
    await this.loadArticle();
  }
}
</script>